import { useEffect, useState } from "react";
import logoDark from "@/assets/Logo Dark.png";
import logoLight from "@/assets/Logo Light.png";

function getCurrentTheme() {
  if (typeof document === "undefined") return "dark";
  return document.documentElement.getAttribute("data-theme") || "dark";
}

export default function BrandLogo({ className = "", alt = "Avinya Research Labs" }) {
  const [theme, setTheme] = useState(getCurrentTheme);

  useEffect(() => {
    const target = document.documentElement;
    const observer = new MutationObserver(() => setTheme(getCurrentTheme()));

    observer.observe(target, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    setTheme(getCurrentTheme());
    return () => observer.disconnect();
  }, []);

  return (
    <img
      src={theme === "light" ? logoLight : logoDark}
      alt={alt}
      className={`block w-auto object-contain ${className}`}
    />
  );
}
